import { atom } from "recoil";

export const trustBoxUpdatedFlagState = atom<boolean>({
  key: "trustBoxUpdatedFlagState",
  default: false,
});
